import React, { useState, useEffect, useRef } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import styled from "styled-components";

import { Link, useLocation } from "react-router-dom";

import ScrollToTop from "../Component/ScrollToTop";

function Navbar() {
  const [isMobile, setIsMobile] = useState(false);
  // const [menuOpen, setMenuOpen] = useState(false);
  const [loginHover, setLoginHover] = useState(false);
  const [registerHover, setRegisterHover] = useState(false);
  const headerRef = useRef(null);

  const location = useLocation();



const isRegisterRoute = location.pathname.startsWith("/register");

// hide buttons as soon as registration starts
const hideAuthButtons =
  isRegisterRoute &&
  (
    localStorage.getItem("basic_ui_step") ||
    localStorage.getItem("profileCreatedById") ||
    localStorage.getItem("registrationProgress")
  );



  const screenWidth = window.innerWidth;

  const dynamicPadding =
    screenWidth <= 1900 && screenWidth >= 1024 ? "8px 100px" : "8px 160px";

  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth <= 992);
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        if (window.scrollY > 50) {
          headerRef.current.style.background =
            "linear-gradient(90deg, #fff8f0 0%, #fff4ef 100%)";
          headerRef.current.style.boxShadow = "0 2px 10px rgba(0, 0, 0, 0.05)";
        } else {
          headerRef.current.style.background = "transparent";
          headerRef.current.style.boxShadow = "none";
        }
      }
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const baseStyles = {
    loginBtn: {
      borderRadius: "200px",
      border: "2px solid rgba(79, 79, 79, 0.2)",
      padding: "10px 28px",
      fontSize: "14px",
      color: "rgba(79, 79, 79, 0.8)",
      cursor: "pointer",
      transition: "all 0.3s ease",
      textAlign: "center",
    },
    registerBtn: {
      borderRadius: "100px",
      border: "2px solid #ff3c3c",
      padding: "10px 34px",
      fontSize: "14px",
      color: "#fff",
      cursor: "pointer",
      transition: "all 0.3s ease",
      textAlign: "center",
    },
  };

  const desktopStyles = {
    navbar: {
      width: "100%",
      position: "fixed",
      top: 0,
      left: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: dynamicPadding,
      background: "transparent",
      zIndex: 1000,
      fontFamily: "'Montserrat', sans-serif",
      fontSize: "15px",
      color: "#1f1f1f",
      transition: "all 0.3s ease",
    },
    logo: { width: "230px", objectFit: "contain" },
    navLinks: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "45px",
      flex: 1,
      fontWeight: 500,
      color: "#2a2a2a",
    },
    navItem: {
      textDecoration: "none",
      color: "#1f1f1f",
      fontWeight: 500,
      cursor: "pointer",
      transition: "color 0.3s ease",
    },
    rightButtons: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
  };

  const mobileStyles = {
    navbar: {
      width: "100%",
      position: "fixed",
      top: 0,
      left: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "16px 20px",
      background: "linear-gradient(90deg, #fff8f0 0%, #fff4ef 100%)",
      zIndex: 200,
      fontFamily: "'Montserrat', sans-serif",
      fontSize: "15px",
      color: "#1f1f1f",
      transition: "all 0.3s ease",
      boxSizing: "border-box",
    },
    logo: { width: "160px", objectFit: "contain", transition: "all 0.3s ease" },
    menuIcon: {
      display: "block",
      cursor: "pointer",
      fontSize: "26px",
      color: "#1f1f1f",
      zIndex: 300,
    },
    mobileMenu: {
      display: "flex",
      flexDirection: "column",
      position: "absolute",
      top: "100%",
      left: 0,
      width: "100%",
      background: "linear-gradient(90deg, #fff8f0 0%, #fff4ef 100%)",
      padding: "20px",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)",
      zIndex: 250,
      alignItems: "center",
      borderTop: "1px solid rgba(0,0,0,0.05)",
      animation: "fadeIn 0.3s ease-in-out",
    },
    mobileNavLinks: {
      display: "flex",
      flexDirection: "column",
      gap: "15px",
      marginBottom: "20px",
      alignItems: "center",
    },
    mobileNavItem: {
      textDecoration: "none",
      color: "#1f1f1f",
      fontWeight: 500,
      fontSize: "16px",
      cursor: "pointer",
      transition: "color 0.3s ease",
    },
    mobileButtons: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      alignItems: "center",
    },
  };

  return (
    <>
      {/* to scroll to the tp od the page */}
      <ScrollToTop />

      {!isMobile ? (
        // ✅ DESKTOP NAVBAR (unchanged from your original)
        <div style={desktopStyles.navbar} ref={headerRef}>
          <div>
            <Link
              to="/"
              style={{ textDecoration: "none", backgroundColor: "transparent" }}
            >
              <img
                src="images/ind-finallogo1.png"
                alt="IND Matrimony - Find Your Perfect Match"
                style={desktopStyles.logo}
              />
            </Link>
          </div>

          {/* <div style={desktopStyles.navLinks}>
            <Link to="/about" style={desktopStyles.navItem}>
              About
            </Link>
            <Link to="/features" style={desktopStyles.navItem}>
              Feature
            </Link>
            <Link to="/success" style={desktopStyles.navItem}>
              Success Stories
            </Link>
            <Link to="/gallery" style={desktopStyles.navItem}>
              Gallery
            </Link>
          </div> */}

          {/* <div style={desktopStyles.rightButtons}>
            <Link
              to="/otpLogin"
              style={{ textDecoration: "none", backgroundColor: "transparent" }}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              onMouseEnter={() => setLoginHover(true)}
              onMouseLeave={() => setLoginHover(false)}
            >
              <div
                style={{
                  ...baseStyles.loginBtn,
                  backgroundColor: loginHover
                    ? "rgba(255, 255, 255, 1)"
                    : "rgba(217, 217, 217, 0.3)",
                }}
              >
                Login
              </div>
            </Link>
            <Link
              to="/register"
              style={{ textDecoration: "none", backgroundColor: "transparent" }}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              onMouseEnter={() => setRegisterHover(true)}
              onMouseLeave={() => setRegisterHover(false)}
            >
              <div
                style={{
                  ...baseStyles.registerBtn,
                  backgroundColor: registerHover ? "#ff3c3c" : "#ff6f61",
                }}
              >
                Register
              </div>
            </Link>
          </div> */}

  {!hideAuthButtons && (
  <div style={desktopStyles.rightButtons}>
    <Link
      to="/otpLogin"
      style={{ textDecoration: "none", backgroundColor: "transparent" }}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      onMouseEnter={() => setLoginHover(true)}
      onMouseLeave={() => setLoginHover(false)}
    >
      <div
        style={{
          ...baseStyles.loginBtn,
          backgroundColor: loginHover
            ? "rgba(255, 255, 255, 1)"
            : "rgba(217, 217, 217, 0.3)",
        }}
      >
        Login
      </div>
    </Link>

    {/* <Link
      to="/register"
      style={{ textDecoration: "none", backgroundColor: "transparent" }}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      onMouseEnter={() => setRegisterHover(true)}
      onMouseLeave={() => setRegisterHover(false)}
    >
      <div
        style={{
          ...baseStyles.registerBtn,
          backgroundColor: registerHover ? "#ff3c3c" : "#ff6f61",
        }}
      >
        Register
      </div>
    </Link> */}

    <Link
  to="/otpLogin?mode=register"
  style={{ textDecoration: "none", backgroundColor: "transparent" }}
>
  <div
    style={{
      ...baseStyles.registerBtn,
      backgroundColor: registerHover ? "#ff3c3c" : "#ff6f61",
    }}
  >
    Register
  </div>
</Link>

  </div>
)}



        </div>
      ) : (
        // ✅ MOBILE NAVBAR (modern embedded look)
        // <div style={mobileStyles.navbar} ref={headerRef}>
        //   <Link
        //     to="/"
        //     style={{ textDecoration: "none", backgroundColor: "transparent" }}
        //   >
        //     <img
        //       src="images/ind-finallogo1.png"
        //       alt="IND Matrimony - Find Your Perfect Match"
        //       style={mobileStyles.logo}
        //     />
        //   </Link>

        //   {/* <div
        //     style={mobileStyles.menuIcon}
        //     onClick={() => setMenuOpen(!menuOpen)}
        //   >
        //     {menuOpen ? <FiX size={26} /> : <FiMenu size={26} />}
        //   </div> */}

        // </div>

        <div
          style={{
            ...mobileStyles.navbar,
            justifyContent: "space-between",
            padding: "12px 16px",
            display: "flex",
            alignItems: "center",
          }}
          ref={headerRef}
        >
          {/* LOGO */}
          <Link to="/" style={{ textDecoration: "none" }}>
            <img
              src="images/ind-finallogo1.png"
              alt="IND Matrimony"
              style={{ width: "133px", objectFit: "contain" }}
            />
          </Link>

          {/* RIGHT SIDE BUTTONS (Always visible) */}


          {/* <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Link 
            to="/otpLogin" 
            style={{ textDecoration: "none" }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <div
                style={{
                  ...baseStyles.loginBtn,
                  padding: "6px 16px",
                  fontSize: "12px",
                  backgroundColor: "rgba(217,217,217,0.4)",
                }}
              >
                Login
              </div>
            </Link>

            <Link 
            to="/register" 
            style={{ textDecoration: "none" }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <div
                style={{
                  ...baseStyles.registerBtn,
                  padding: "6px 18px",
                  fontSize: "12px",
                  backgroundColor: "#ff6f61",
                }}
              >
                Register
              </div>
            </Link>
          </div> */}

          {!hideAuthButtons && (
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Link 
            to="/otpLogin" 
            style={{ textDecoration: "none" }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <div
                style={{
                  ...baseStyles.loginBtn,
                  padding: "6px 16px",
                  fontSize: "12px",
                  backgroundColor: "rgba(217,217,217,0.4)",
                }}
              >
                Login
              </div>
            </Link>

            {/* <Link 
            to="/register" 
            style={{ textDecoration: "none" }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <div
                style={{
                  ...baseStyles.registerBtn,
                  padding: "6px 18px",
                  fontSize: "12px",
                  backgroundColor: "#ff6f61",
                }}
              >
                Register
              </div>
            </Link> */}

            <Link
  to="/otpLogin?mode=register"
  style={{ textDecoration: "none", backgroundColor: "transparent" }}
>
  <div
    style={{
      ...baseStyles.registerBtn,
      padding: "6px 18px",
                  fontSize: "12px",
      backgroundColor: registerHover ? "#ff3c3c" : "#ff6f61",
    }}
  >
    Register
  </div>
</Link>

          </div> 
)}



        </div>
      )}
    </>
  );
}

export default Navbar;
